import { Link } from "@tanstack/react-router"
import { ArrowRight, CalendarDays } from "lucide-react"

import type { ContentItem } from "@/lib/types"

export function EditorialIndex({
  eyebrow,
  title,
  intro,
  items,
  kind,
}: {
  eyebrow: string
  title: string
  intro: string
  items: ContentItem[]
  kind: "news" | "events"
}) {
  return (
    <div className="field-container py-12">
      <header className="grid gap-6 border-b-2 border-foreground pb-8 lg:grid-cols-[1fr_1fr] lg:items-end">
        <div>
          <p className="field-label">{eyebrow}</p>
          <h1 className="field-heading mt-3">{title}</h1>
        </div>
        <p className="max-w-xl text-base leading-7 text-muted-foreground">
          {intro}
        </p>
      </header>
      <div className="mt-8 grid gap-px border bg-border lg:grid-cols-3">
        {items.map((item, index) => (
          <article key={item.id} className="group flex flex-col bg-white">
            {item.imageUrl ? (
              <div className="relative h-64 overflow-hidden bg-muted">
                <img
                  src={item.imageUrl}
                  alt=""
                  className="size-full object-cover transition-transform duration-300 group-hover:scale-[1.025]"
                />
                <span className="field-marker absolute top-4 left-4">
                  {index + 1}
                </span>
              </div>
            ) : null}
            <div className="field-rule flex flex-1 flex-col p-6">
              {item.startsAt ? (
                <p className="flex items-center gap-2 text-xs font-semibold text-primary">
                  <CalendarDays className="size-4" />
                  {new Intl.DateTimeFormat("en-US", {
                    dateStyle: "medium",
                    timeStyle: kind === "events" ? "short" : undefined,
                  }).format(new Date(item.startsAt))}
                </p>
              ) : null}
              <h2 className="mt-4 font-heading text-3xl leading-none font-semibold uppercase">
                {item.title}
              </h2>
              <p className="mt-4 text-sm leading-6 text-muted-foreground">
                {item.excerpt}
              </p>
              <details className="mt-6 border-t pt-4">
                <summary className="flex cursor-pointer list-none items-center gap-2 font-heading text-sm font-bold tracking-wider uppercase">
                  Open field note <ArrowRight className="size-4" />
                </summary>
                <p className="mt-4 text-sm leading-6 text-muted-foreground">
                  {item.body}
                </p>
                {kind === "events" ? (
                  <Link
                    to="/contact"
                    search={{ subject: item.title }}
                    className="field-link mt-4 inline-block text-sm font-semibold"
                  >
                    Ask about this demo event
                  </Link>
                ) : null}
              </details>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
